<template>
  <div
    class="volume-adjust"
    v-if="boxData.judgeBox"
    :style="{
      top: boxData.fix.y + 'px',
      left: boxData.fix.x + 'px',
      'z-index': boxData.Zindex,
    }"
    @mousedown="stopDocument($event)"
  >
    <audio
      id="vol-bgm-audio"
      style="display: none"
      :src="$handleAssetsUrl(BGM.url)"
      controls
    ></audio>
    <audio
      id="vol-rec-audio"
      style="display: none"
      :src="$handleAssetsUrl(record.url)"
      controls
    ></audio>
    <div
      class="header"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{ cursor: 'move' }"
    >
      <span>声音管理</span>
      <i @click="close" class="icon-popup-close"></i>
    </div>
    <div class="volume-container">
      <div class="mask">
        <p>
        <span class="strong">声音功能全新升级</span>，声音管理面板即将下线，
          请点击右上角<span class="strong">“声音与字幕”</span>进行配音、配乐 添加和设置。
        </p>
      </div>
      <div class="adjust-panel">
        <div class="all-pages">
          <div class="page">
            <i class="music-icon"></i>
            <p>背景音乐</p>
            <p class="range">(覆盖全部页面)</p>
          </div>
          <div class="bgm-detail" v-if="BGM.url">
            <div class="sound-title">
              <span class="name">{{ BGM.title || '暂无背景音乐' }}</span>
              <div class="volume-bar">
                <i class="volume-icon"></i>
                <div
                  class="rc-slider"
                  :class="BGM.resourceId ? '' : 'hide-slider'"
                >
                  <div class="rc-slider-rail"></div>
                  <div
                    class="rc-slider-track"
                    :style="{ width: allPagesVolume + '%' }"
                  ></div>
                  <div
                    v-dragHandle
                    data-vol="all"
                    class="rc-slider-handle"
                    :style="{ left: allPagesVolume + '%' }"
                  ></div>
                </div>
                <div class="volume-tip">{{ allPagesVolume }}</div>
              </div>
            </div>
            <span v-if="cropSound.play && !isPlay" class="duration"
              >{{ cropSound.playCurrentTime | formatTime }}/{{
                cropSound.endTime | formatTime
              }}</span
            >
            <span v-if="!cropSound.play && !isPlay" class="duration"
              >{{ cropSound.startTime | formatTime }}/{{
                cropSound.endTime | formatTime
              }}</span
            >
            <span v-if="!cropSound.play && isPlay" class="duration"
              >{{ bgmCurrent | formatTime }}/{{
                cropSound.endTime | formatTime
              }}</span
            >
          </div>
          <div class="control-btns" v-if="BGM.url">
            <div
              style="
                width: 100%;
                display: inline-flex;
                justify-content: space-between;
                margin-bottom: 5px;
              "
            >
              <div class="cropSound" @click="cropSoundStep(1)"></div>
              <span
                :class="isBGMpaused ? 'play' : 'stop'"
                @click="cropPlaySound()"
              ></span>
              <span
                class="del-icon"
                @click="
                  materialPushAnalysis({ type: 'toolSoundDelete' });
                  delBGM();
                "
              ></span>
            </div>
            <div
              style="
                display: flex;
                justify-content: flex-end;
                align-items: center;
              "
            >
              <input id="loop" type="checkbox" v-model="BGM.isLoop" />
              <label for="loop">
                <span
                  @click="materialPushAnalysis({ type: 'toolSoundLoop' })"
                ></span
                >循环
              </label>
            </div>
          </div>
          <div
            class="no-bgm"
            v-if="!BGM.url"
            v-analysis="BaiduAnalysis.managementAddBgMusic"
            @click="openRightNav('sound')"
          >
            <!-- 你还没有添加背景音乐哦~ -->
            <i class="icon-big-plus"></i>
            <span>点击添加背景音乐</span>
          </div>
        </div>
        <div class="current-page">
          <div class="page">
            <i class="mic-icon"></i>
            <p>录音</p>
            <!-- <p style="color: #737596;">{{SelectScenes_Msg.index+1}} / {{TOOL && TOOL.sprites.length}}</p> -->
            <p class="range">
              {{
                TOOL.soundRecordMode === 'global'
                  ? '(覆盖全部页面)'
                  : '(覆盖当前页面)'
              }}
            </p>
          </div>
          <div class="record-detail" v-if="record.url">
            <div class="sound-title">
              <span class="name">{{ record.title }}</span>
              <div class="volume-bar">
                <i class="volume-icon"></i>
                <div
                  class="rc-slider"
                  :class="record.resourceId ? '' : 'hide-slider'"
                >
                  <div class="rc-slider-rail"></div>
                  <div
                    class="rc-slider-track"
                    :style="{ width: currentPageVolume + '%' }"
                  ></div>
                  <div
                    v-dragHandle
                    data-vol="current"
                    class="rc-slider-handle"
                    :style="{ left: currentPageVolume + '%' }"
                  ></div>
                </div>
                <div class="volume-tip">{{ currentPageVolume }}</div>
              </div>
            </div>
            <span class="duration"
              >{{ recCurrent | formatTime }}/{{
                record.duration | formatTime
              }}</span
            >
          </div>
          <div
            class="control-btns"
            v-if="record.url"
            style="display: inline-flex; justify-content: flex-end"
          >
            <span
              style="margin-right: 15px"
              :class="isRecPaused ? 'play' : 'stop'"
              @click="playRec"
            ></span>
            <span class="del-icon" @click="delRec"></span>
          </div>
          <div
            class="no-record"
            v-if="!record.url"
            v-analysis="BaiduAnalysis.managementAddVoice"
            @click="openRightNav('record')"
          >
            <!-- 你还没有添加录音哦~ -->
            <i class="icon-big-plus"></i>
            <span>点击添加录音</span>
          </div>
        </div>
      </div>

      <transition name="slide-fade">
        <!-- @mousemove = "cropMoveArea($event)"
        @mouseup   = "cropSaveMoveState($event)"
        @mouseleave="cropSaveMoveState($event)"-->
        <div class="cropSoundBox" v-if="cropSound.step == 1">
          <div class="arrowBtn" @click="cropSoundStep(0)">
            <span class="icon icon-editor-undo"></span>返回
          </div>
          <div style="margin-bottom: 50px">
            背景音乐：
            {{ BGM.title }}
          </div>

          <div class="cropTool">
            <div class="scaleBar" ref="scaleBarEl">
              <div
                class="scaleBarBg"
                :style="{
                  width: cropSound.scaleBar.width + 'px',
                  left: cropSound.scaleBar.pox + 'px',
                }"
              ></div>

              <div
                class="scaleBarBtn"
                :style="{
                  width: cropSound.scaleBar.width + 'px',
                  left: cropSound.scaleBar.pox + 'px',
                }"
              >
                <div v-if="!cropSound.play" class="timeIconLeft">
                  <span>{{ cropSound.startTime | formatTime }}</span>
                </div>
                <div v-if="!cropSound.play" class="timeIconRight">
                  <span>{{ cropSound.endTime | formatTime }}</span>
                </div>
                <!-- @mousedown = "cropMoveStart($event, 'left')"
                  @mousemove = "cropMoveArea($event)"
                @mouseup   = "cropSaveMoveState($event)"-->
                <div
                  class="scaleBarBtnLeft el-icon-arrow-left"
                  v-dragged="onDraggedLeft"
                  :style="{
                    'z-index': cropSound.scaleBar.pox >= 370 ? 10 : 0,
                  }"
                  ref="scaleBarBtnLeft"
                ></div>
                <!-- @mousedown = "cropMoveStart($event, 'right')"
                  @mousemove = "cropMoveArea($event)"
                @mouseup   = "cropSaveMoveState($event)"-->
                <div
                  class="scaleBarBtnRight el-icon-arrow-right"
                  v-dragged="onDraggedRight"
                  :style="{
                    'z-index':
                      cropSound.scaleBar.width <= 5 &&
                      cropSound.scaleBar.pox <= 370
                        ? 10
                        : 0,
                  }"
                  ref="scaleBarBtnRight"
                ></div>
              </div>

              <div
                class="timeBar"
                v-if="cropSound.play"
                :style="{
                  left: cropSound.playPox + 'px',
                }"
              >
                <span>{{ cropSound.playCurrentTime | formatTime }}</span>
              </div>
            </div>

            <div class="soundDuration">
              {{ this.BGM.duration | formatTime }}s
            </div>
          </div>

          <div class="cropBtnBox">
            <div
              @click="
                cropPlaySound();
                materialPushAnalysis({ type: 'cropSoundListen' });
              "
              class="cropBtn"
              :class="{
                'el-icon-caret-right': !cropSound.play,
                cropBtnRectangle: cropSound.play,
              }"
            ></div>
          </div>
        </div>
      </transition>

      <div class="audition">
        <span
          v-if="BGM.url && record.url && cropSound.step == 0"
          :class="isPlay ? 'stop' : 'play'"
          @click="play()"
        ></span>
        <span v-if="BGM.url && record.url">同时播放</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popup from "../mixins/popup";
import Analysis from "../mixins/analysis/materialBu";

export default {
  mixins: [popup, Analysis],
  data () {
    return {
      isPlay: false,
      isBGMLoaded: false,
      isRecordLoaded: false,
      timer: "",
      BGMaudio: "", // 单独为背景音乐时长设置的
      recordAudio: "",
      startTime: 0, // 场景页开始时间
      endTime: 0, // 场景页结束时间
      currentTime: 0, // 背景音乐
      isLoaded: false,
      BGM: {
        title: "",
        duration: 0
      }, // 全局音乐
      record: {
        title: "录音20180718",
        duration: 12
      }, // 录音
      currentPageVolume: 50,
      allPagesVolume: 50,
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        moveoks: false, // 拖动判读啊数据
        oldMove: {
          // 计算移动增量
          x: 0,
          y: 0
        },
        fix: {
          // 弹窗位置
          x: 0,
          y: 0
        }
      },
      clickListSound: false,
      volBGM: "", // 背景音乐audio标签
      isBGMpaused: true,
      volRec: "", // 录音audio标签
      isRecPaused: true,
      playAll: false,
      bgmCurrent: 0,
      recCurrent: 0,
      timer: "",
      cropSound: {
        // 剪辑音乐
        step: 0, // 步骤
        moveoks: false, // 移动启动
        pagexL: 0, // 左箭头坐标
        pagexR: 0, // 右箭头坐标
        AllWidth: 380, // 剪辑条长度
        scaleBar: {
          // 播放区域的宽和定位
          width: 0,
          pox: 0
        },
        startTime: 0,
        endTime: 0,
        play: false,
        playPox: 0,
        playCurrentTime: 0
      }
    };
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "TopNav_Size",
      "MaterialPane_Size",
      "Tool_Size",
      "SelectScenes_Msg"
    ])
  },
  filters: {
    formatTime (duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    }
  },
  watch: {
    "boxDatas.firstDatas": function (val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "volume_adjust");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        this.cropSound.step = 0;
        this.clickListSound = true;
        this.boxData.data = this.dataMsg.volume_adjust;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.fix.x =
          this.MaterialPane_Size.width + this.Tool_Size.width - 508;
        this.boxData.fix.y =
          this.TopNav_Size.height + this.Tool_Size.height - 320;
      } else {
        this.cropSound.play = false;
        if (this.clickListSound) {
          this.clickListSound = false;
          if (this.BGM.url && this.record.url && this.isPlay) {
            this.$bus.emit("timeline_play_scenes", {
              nowTime: 0,
              isPlay: false
            });
          }
        }
      }
    },
    StyleMsg (val, oldVal) {
      if (val) {
        // 获取背景音乐音量
        this.allPagesVolume = this.TOOL.getSound()
          ? this.TOOL.getSound().volume
          : 50;
        this.currentPageVolume = this.TOOL.selectedScenes.getSound()
          ? this.TOOL.selectedScenes.getSound().volume
          : 50;
      }
    },
    "TOOL.sound": async function () {
      // 监控bgm改变
      if (this.TOOL.sound) {
        this.BGM = Object.assign({}, this.BGM, this.TOOL.getSound());
        if (this.BGM.url) {
          this.BGM.duration = await this.$util.getMediaDuration(
            this.$handleAssetsUrl(this.BGM.url)
          );
          // this.getSoundById(this.BGM.resourceId);
          this.initializationSound();
        }
        this.allPagesVolume = this.TOOL.getSound().volume;
      } else {
        this.BGM = {
          title: "暂无背景音乐",
          duration: 0
        };
        this.allPagesVolume = 50;
      }
    },
    "SelectScenes_Msg.sound": function (val, oldval) {
      // 加载分组音乐
      if (this.TOOL.soundRecordMode === "global") {
        this.record = Object.assign(
          {},
          this.record,
          this.TOOL.getSound("record")
        );
        if (this.record.resourceId) {
          this.getRecordById(this.record.resourceId);
        }
        this.currentPageVolume = this.TOOL.getSound("record").volume;
        return;
      }
      if (this.SelectScenes_Msg.sound) {
        this.record = Object.assign(
          {},
          this.record,
          this.TOOL.selectedScenes.getSound()
        );
        if (this.record.resourceId) {
          this.getRecordById(this.record.resourceId);
        }
        this.currentPageVolume = this.TOOL.selectedScenes.getSound().volume;
      } else {
        this.record = {
          title: "暂无录音",
          duration: 0
        };
        this.currentPageVolume = 50;
      }
    },
    "TOOL.soundRecord" (val) {
      if (val) {
        this.record = Object.assign(
          {},
          this.record,
          this.TOOL.getSound("record")
        );
        if (this.record.resourceId) {
          this.getRecordById(this.record.resourceId);
        }
        this.currentPageVolume = this.TOOL.getSound("record").volume;
      } else {
        if (!this.SelectScenes_Msg.sound) {
          this.record = {
            title: "暂无录音",
            duration: 0
          };
          this.currentPageVolume = 50;
        }
      }
    },
    "BGM.isLoop" () {
      let soundData = this.TOOL.getSound();
      soundData.isLoop = this.BGM.isLoop;
      this.clickListSound && this.TOOL.setSound(soundData, true);
    },
    "boxData.judgeBox" (val) {
      if (!val) {
        // 关闭弹窗后停止播放
        this.endPlay();
      }
      if (val) {
        this.$bus.emit('showNewSoundMsg', true);
      }
    },
    "TOOL.option.width": function (val) {
      this.boxData.fix.x =
        this.MaterialPane_Size.width + this.Tool_Size.width - 482;
      this.boxData.fix.y =
        this.TopNav_Size.height + this.Tool_Size.height - 320;
    }
  },
  directives: {
    dragHandle (el, binding, vnode) {
      let _this = vnode.context,
        nowVolume = 0,
        mousemove = null,
        mouseup = null,
        vol = null,
        disx = 0;

      mousemove = e => {
        // 拖动改变音量
        if (vol === "all") {
          _this.allPagesVolume = ~~(((e.pageX - disx) / 114) * 100 + nowVolume);
          _this.allPagesVolume =
            _this.allPagesVolume < 0
              ? 0
              : _this.allPagesVolume > 100
                ? 100
                : _this.allPagesVolume;
        } else {
          _this.currentPageVolume = ~~(
            ((e.pageX - disx) / 114) * 100 +
            nowVolume
          );
          _this.currentPageVolume =
            _this.currentPageVolume < 0
              ? 0
              : _this.currentPageVolume > 100
                ? 100
                : _this.currentPageVolume;
        }
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        _this.adjustVolume(vol);
        if (_this.playAll) {
          _this.play();
        }
      };

      el.onmousedown = e => {
        e.preventDefault();
        e.stopPropagation();

        disx = e.pageX;
        vol = e.target.dataset.vol;

        nowVolume =
          vol === "all" ? _this.allPagesVolume : _this.currentPageVolume;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
        if (_this.playAll) {
          _this.play();
        }
      };
    }
  },
  mounted () {
    // sound.vue页面
    this.BGMaudio = document.getElementById("bgm-audio");
    this.$bus.on("Document_mousemove_vue", event => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on("Document_mouseup_vue", event => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.saveMoveState(e);
        return false;
      }
    });
    this.$bus.on("stop_sound_vue", () => {
      this.isPlay = false;
    });
    this.$bus.on("SoundScenesCurrentTime", data => {
      this.recCurrent = data.time;
    });
    this.$bus.on("SoundBGCurrentTime", data => {
      this.bgmCurrent = data.time;
    });
  },
  methods: {
    getSoundById (resourceId) {
      this.$http
        .get("/api/common/material?type=5&id=" + resourceId)
        .then(res => {
          if (res.data.data) {
            this.BGM.title = res.data.data.title || "未命名";
            this.BGM.duration = res.data.data.duration || 0;
          } else {
            this.$http
              .get(
                "/api/user/music?sOfPage=24&fPage=24&pIndex=1&type=5&musicType=0&id=" +
                resourceId
              )
              .then(res => {
                if (!res.data.data) return;
                this.BGM.title = res.data.data.title || "未命名";
                this.BGM.duration = res.data.data.duration || 0;
              });
          }
        });
    },
    getRecordById (resourceId) {
      this.$http
        .get(
          "/api/user/music?sOfPage=24&fPage=24&pIndex=1&type=5&musicType=1&id=" +
          resourceId
        )
        .then(res => {
          if (!res.data.data) {
            this.$util.getMediaDuration(this.record.url).then(d => {
              this.record.duration = d;
            });

            return;
          }
          this.record.title = res.data.data.title || "未命名";
          this.record.duration = res.data.data.duration || 0;
        });
    },
    delBGM () {
      this.BGM = {
        resourceId: "",
        title: "",
        fileType: null,
        url: "",
        duration: 0,
        isLoop: true,
        volume: 50
      };
      this.TOOL.setSound({}, true);
      this.isBGMpaused = true;
      this.bgmCurrent = 0;
      if (this.isPlay) {
        this.play();
      }
    },
    delRec () {
      if (this.TOOL.soundRecordMode === "global") {
        this.TOOL.clearSoundRecord({ undo: true });
      } else {
        this.TOOL.selectedScenes.clearSound();
      }
      this.isRecPaused = true;
      this.recCurrent = 0;
      if (this.isPlay) {
        this.play();
      }
    },
    playx () {
      this.volBGM = document.getElementById("vol-bgm-audio");
      this.volRec = document.getElementById("vol-rec-audio");
      if (this.playAll) {
        this.volBGM.pause();
        this.volBGM.currentTime = 0;
        this.volRec.pause();
        this.volRec.currentTime = 0;
        this.playAll = false;
        return;
      }

      this.volBGM.volume = this.BGM.volume / 100;
      this.volBGM.play();

      this.volRec.volume = this.record.volume / 100;
      this.volRec.play();
      this.isPlay = false;
      this.playAll = true;
    },
    play () {
      // 同时播放
      this.$bus.emit("stop_listen_BGM");
      if (!this.isBGMpaused) {
        this.playBGM();
      }
      if (!this.isRecPaused) {
        this.playRec();
      }

      this.isPlay = !this.isPlay;
      this.playAll = this.isPlay;
      this.$bus.emit("timeline_play_scenes", {
        nowTime:
          this.SelectScenes_Msg.nowTime === undefined
            ? 1
            : this.SelectScenes_Msg.nowTime,
        isPlay: this.isPlay
      });
    },
    playBGM () {
      this.timer = clearInterval(this.timer);
      this.playAll = false;
      this.volBGM = document.getElementById("vol-bgm-audio");
      this.volBGM.volume = this.BGM.volume / 100;
      this.volBGM.removeEventListener("ended", this.endPlay);
      this.volBGM.addEventListener("ended", this.endPlay);
      // 播放背景音乐
      if (this.volBGM.paused) {
        if (!this.isRecPaused) {
          this.playRec();
        }
        if (this.isPlay) {
          this.play();
        }
        this.volBGM.play();
        this.isBGMpaused = false;
        this.materialPushAnalysis({ type: "toolSoundListen" });
        this.timer = setInterval(() => {
          this.bgmCurrent = this.volBGM.currentTime;
        }, 100);
      } else {
        this.volBGM.pause();
        this.bgmCurrent = this.volBGM.currentTime = 0;
        this.isBGMpaused = true;
      }
    },
    playRec () {
      this.timer = clearInterval(this.timer);
      this.playAll = false;
      this.volRec = document.getElementById("vol-rec-audio");
      this.volRec.volume = this.record.volume / 100;
      this.volRec.removeEventListener("ended", this.endPlay);
      this.volRec.addEventListener("ended", this.endPlay);
      // 播放录音
      if (this.volRec.paused) {
        if (!this.isBGMpaused) {
          this.playBGM();
        }
        if (this.isPlay) {
          this.play();
        }
        this.volRec.play();
        this.isRecPaused = false;
        this.timer = setInterval(() => {
          this.recCurrent = this.volRec.currentTime;
        });
      } else {
        this.volRec.pause();
        this.recCurrent = this.volRec.currentTime = 0;
        this.isRecPaused = true;
      }
    },
    endPlay () {
      if (!this.isBGMpaused) {
        this.isBGMpaused = true;
        this.bgmCurrent = 0;
        this.volBGM && this.volBGM.removeEventListener("ended", this.endPlay);
      }
      if (!this.isRecPaused) {
        this.isRecPaused = true;
        this.recCurrent = 0;
        this.volRec.removeEventListener("ended", this.endPlay);
      }
      this.timer = clearInterval(this.timer);
    },
    delSound (type) {
      // 删除背景音乐或录音
      switch (type) {
        case "bgm":
          this.BGM = {
            resourceId: "",
            title: "",
            fileType: null,
            url: "",
            duration: 0,
            isLoop: true,
            volume: 50
          };
          this.TOOL.setSound(
            {
              resourceId: "",
              title: "",
              fileType: null,
              url: "",
              isLoop: true,
              volume: 50,
              subtitle: null
            },
            true
          );
          break;

        case "rec":
          this.record = {
            resourceId: "",
            title: "",
            fileType: null,
            url: "",
            duration: 0,
            isLoop: true,
            volume: 50
          };
          this.TOOL.selectedScenes.setSound(
            {
              resourceId: "",
              title: "",
              fileType: null,
              url: "",
              isLoop: true,
              volume: 50,
              subtitle: null
            },
            true
          );
          break;
      }
    },
    adjustVolume (page) {
      this.volRec = document.getElementById("vol-rec-audio");
      this.volBGM = document.getElementById("vol-bgm-audio");

      // todo
      if (page === "all") {
        this.volBGM.volume = this.allPagesVolume / 100;
        this.$bus.emit("setting-BGM-vol", this.allPagesVolume);
        if (this.TOOL.sound.volume) {
          this.TOOL.sound.volume = this.allPagesVolume;
        }
        // this.TOOL.setSound({
        //   volume: this.allPagesVolume
        // }, true)
      } else if (page === "current" && this.TOOL.soundRecordMode !== "global") {
        this.volRec.volume = this.currentPageVolume / 100;
        this.$bus.emit("setting-record-vol", this.currentPageVolume);
        this.TOOL.selectedScenes.setSound({
          volume: this.currentPageVolume
        });
      } else if (this.TOOL.soundRecordMode === "global") {
        this.volRec.volume = this.currentPageVolume / 100;
        if (this.TOOL.soundRecord.volume) {
          this.TOOL.soundRecord.volume = this.currentPageVolume;
          // this.TOOL.setSoundRecord({
          //   volume: this.currentPageVolume
          // }, 'global', true)
        }
      }
      this.$bus.emit("scenes_soundUpdata_vue");
    },
    close () {
      //FeaturesPop_close_vue
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "volume_adjust",
        type: 1
      });
    },
    openRightNav (type) {
      if (type === "record") {
        this.$bus.emit("collectPersonal_vue", { data: "collectMusicType" });
        return;
      }
      this.$bus.emit("materialPane_vue", { type });
    },
    cropSoundStep (data) {
      this.cropPlaySound(true);
      this.cropSound.step = data;
      switch (data) {
        case 1:
          this.materialPushAnalysis({ type: "cropSoundBoxOn" });
          break;
        default:
          this.materialPushAnalysis({ type: "cropSoundBoxOff" });
      }
    },
    onDraggedLeft (params) {
      this.onDragged(params, "left");
    },
    onDraggedRight (params) {
      this.onDragged(params, "right");
    },
    onDragged (params, type) {
      let { first, last, clientX, clientY, deltaX } = params;
      let m = {
        pageX: clientX,
        pageY: clientY
      };
      if (first) {
        this.cropMoveStart(m, type);
      }
      if (last) {
        this.cropSaveMoveState(m);
        this.cropSound.moveoks = false;
      }

      if (!this.cropSound.moveoks) {
        return;
      }

      let wayRect = this.cropSound.wayRect;
      let prevMoveIn = this.cropSound.moveIn;
      let d = (this.cropSound.AllWidth * 5) / this.BGM.duration;
      let startEdge = this.cropSound.leftBtnPos + d;
      let endEdge = wayRect.right;
      if (type === "left") {
        startEdge = wayRect.left;
        endEdge = this.cropSound.rightBtnPos - d;
        // if (deltaX > 0 && startEdge <= clientX || deltaX < 0 && startEdge <= endEdge) {
        //   this.cropSound.moveIn = true;
        // }
      }
      if (startEdge <= clientX && clientX <= endEdge) {
        this.cropSound.moveIn = true;
        if (this.cropSound.moveIn && prevMoveIn === false) {
          this.cropSound.pagexL = clientX;
        }
      } else {
        if (type === "left" && clientX >= endEdge) {
          this.cropSound.startTime = this.cropSound.endTime * 1 - 5;
          this.cropSound.scaleBar.pox =
            (this.cropSound.startTime / this.BGM.duration) *
            this.cropSound.AllWidth;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth * 5) / this.BGM.duration;
        }
        if (type === "left" && clientX <= startEdge) {
          this.cropSound.startTime = 0;
          this.cropSound.scaleBar.pox = 0;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth *
              (this.cropSound.endTime - this.cropSound.startTime)) /
            this.BGM.duration;
        }
        if (type === "right" && clientX <= startEdge) {
          this.cropSound.endTime = this.cropSound.startTime * 1 + 5;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth * 5) / this.BGM.duration;
        }
        if (type === "right" && clientX >= endEdge) {
          this.cropSound.endTime = this.BGM.duration;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth *
              (this.cropSound.endTime - this.cropSound.startTime)) /
            this.BGM.duration;
        }
        this.cropSound.moveIn = false;
      }
      this.cropMoveArea(m);
    },
    cropMoveStart (e, type) {
      // 移动启动
      this.cropSound.moveoks = type;
      this.cropSound.moveIn = true;
      if (this.cropSound.play) {
        this.cropPlaySound();
      }
      switch (type) {
        case "left":
          this.materialPushAnalysis({ type: "cropSoundBtnleft" });
          this.cropSound.pagexL = e.pageX;
          break;
        case "right":
          this.materialPushAnalysis({ type: "cropSoundBtnright" });
          this.cropSound.pagexR = e.pageX;
          break;
      }
      // e.onselectstart = () => { //防止IE文字选中
      // 	return false;
      // }
      this.cropSound.wayRect = this.$refs.scaleBarEl.getBoundingClientRect();
      this.cropSound.leftBtnPos = this.$refs.scaleBarBtnLeft.getBoundingClientRect().right;
      this.cropSound.rightBtnPos = this.$refs.scaleBarBtnRight.getBoundingClientRect().left;
    },
    cropMoveArea (e) {
      // 拖动元素计算
      if (this.cropSound.moveIn) {
        switch (this.cropSound.moveoks) {
          case "left":
            let leftX = this.cropSound.pagexL - e.pageX;

            if (
              this.cropSound.scaleBar.width + leftX > 0 &&
              this.cropSound.scaleBar.pox >= 0 &&
              this.cropSound.scaleBar.pox - leftX >= 0
            ) {
              this.settingSoundData({
                startTime: this.cropSound.pagexL - e.pageX
              });
              if (this.cropSound.scaleBar.pox - leftX == 0) {
                this.settingSoundData({
                  startTime: this.cropSound.scaleBar.pox
                });
              }
            } else {
              if (this.cropSound.scaleBar.pox - leftX < 0) {
                this.settingSoundData({
                  startTime: this.cropSound.scaleBar.pox
                });
              }
              this.cropSound.moveIn = false;
            }
            this.cropSound.pagexL = e.pageX;
            break;
          case "right":
            let rightX = e.pageX - this.cropSound.pagexR;
            if (
              this.cropSound.scaleBar.width + rightX > 0 &&
              this.cropSound.AllWidth >
              this.cropSound.scaleBar.width +
              this.cropSound.scaleBar.pox +
              rightX
            ) {
              this.settingSoundData({
                endTime: e.pageX - this.cropSound.pagexR
              });
            } else {
              this.cropSound.scaleBar.width = 380 - this.cropSound.scaleBar.pox;
              this.cropSound.endTime = this.BGM.duration;
              this.cropSound.moveIn = false;
            }
            this.cropSound.pagexR = e.pageX;
            break;
        }
      }
    },
    cropSaveMoveState (e) {
      // 保存移动状态
      if (this.cropSound.moveoks) {
        let soundData = this.TOOL.getSound();
        soundData.startTime = this.cropSound.startTime * 1000;
        soundData.endTime =
          (this.cropSound.endTime == this.BGM.duration
            ? this.BGM.duration * 1000
            : this.cropSound.endTime) * 1000;
        // console.log(soundData)
        this.TOOL.setSound(soundData);
        this.cropSound.moveoks = false;
      }
    },
    initializationSound (data) {
      // 初始化背景音乐
      let duration = this.BGM.duration,
        SoundBG = this.TOOL.getSound();
      let soundEndTime = SoundBG.endTime;

      this.cropSound.play = false;
      if (SoundBG.endTime / 1000 >= duration) {
        soundEndTime = 0;
      }
      this.cropSound.scaleBar.pox =
        (SoundBG.startTime / 1000 / duration) * this.cropSound.AllWidth;
      let endPox =
        ((soundEndTime > 0 ? soundEndTime / 1000 : duration) / duration) *
        this.cropSound.AllWidth;
      this.cropSound.scaleBar.width = endPox - this.cropSound.scaleBar.pox;

      this.cropSound.startTime = SoundBG.startTime / 1000;
      this.cropSound.endTime = soundEndTime / 1000 || duration;
    },
    settingSoundData (data) {
      // 设置背景音乐位置
      let pox = this.cropSound.scaleBar.pox,
        width = this.cropSound.scaleBar.width;

      for (let itemAttr in data) {
        switch (itemAttr) {
          case "startTime":
            if (
              data[itemAttr] < 0 &&
              this.cropSound.endTime - this.cropSound.startTime < 5
            )
              return;
            pox -= data[itemAttr];
            width += data[itemAttr];
            break;
          case "endTime":
            if (
              data[itemAttr] < 0 &&
              this.cropSound.endTime - this.cropSound.startTime < 5
            )
              return;
            width += data[itemAttr];
            break;
        }
      }
      if (
        (((pox + width) / this.cropSound.AllWidth) * this.BGM.duration).toFixed(
          2
        ) -
        ((pox / this.cropSound.AllWidth) * this.BGM.duration).toFixed(2) >=
        5
      ) {
        this.cropSound.scaleBar.pox = pox;
        this.cropSound.scaleBar.width = width;
        this.cropSound.startTime = (
          (this.cropSound.scaleBar.pox / this.cropSound.AllWidth) *
          this.BGM.duration
        ).toFixed(2);
        this.cropSound.endTime = (
          ((this.cropSound.scaleBar.pox + this.cropSound.scaleBar.width) /
            this.cropSound.AllWidth) *
          this.BGM.duration
        ).toFixed(2);
        this.cropSound.endTime = Math.min(
          this.cropSound.endTime,
          this.BGM.duration
        );
      } else {
      }
      this.cropSound.scaleBar.width;
    },
    cropPlaySound (data) {
      // 播放音乐
      let cropSoundDom = document.getElementById("vol-bgm-audio"),
        cropSoundDomFS = () => {
          if (cropSoundDom.currentTime > this.cropSound.endTime) {
            cropSoundDom.pause();
            this.cropSound.play = false;
            this.isBGMpaused = true; // 音乐设置面板
            this.cropSound.playCurrentTime = this.cropSound.startTime;
          } else {
            this.cropSound.playPox =
              (cropSoundDom.currentTime / duration) * this.cropSound.AllWidth;
            this.cropSound.playCurrentTime = cropSoundDom.currentTime;
          }
        };
      let duration = cropSoundDom.duration;
      if (this.cropSound.play || data || !cropSoundDom.paused) {
        cropSoundDom.pause();
        this.isBGMpaused = true; // 音乐设置面板
        this.cropSound.play = false;
      } else {
        cropSoundDom.currentTime = this.cropSound.startTime;
        this.cropSound.playCurrentTime = cropSoundDom.currentTime;
        this.cropSound.playPox =
          (cropSoundDom.currentTime / duration) * this.cropSound.AllWidth;
        cropSoundDom.addEventListener("timeupdate", cropSoundDomFS);
        cropSoundDom.play();
        this.isBGMpaused = false; // 音乐设置面板
        this.cropSound.play = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.volume-container {
  position: relative;
  & > .mask {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#fff, 0.9);
    z-index: 1;
    & > p {
      width: 320px;
      height: 77px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      line-height: 28px;
      color: #474261;
      opacity: 1;
      text-align: left;
    }
    & .strong {
      font-weight: bold;
      color: #5778FB;
    }
  }
}
.volume-adjust {
  position: fixed;
  top: 0;
  left: 0;
  width: 502px;
  height: 308px;
  z-index: 35;
  background: #fff;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  box-sizing: border-box;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 15px;
    height: 28px;
    background-color: #d8dee9;
    span {
      // width: 58px;
      color: #474261;
    }
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .volume-container {
    position: relative;
    height: 282px;
    .adjust-panel {
      width: 100%;
      height: 212px;
      color: #474261;
      padding: 0 25px;
      // 进度条容器
      .rc-slider {
        display: inline-block;
        flex-shrink: 0;
        position: relative;
        height: 16px;
        padding: 5px 0;
        width: 114px;
        -ms-touch-action: none;
        touch-action: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

        * {
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
        // 底色
        .rc-slider-rail {
          position: absolute;
          width: 100%;
          background-color: #e7e7fb;
          height: 4px;
          border-radius: 2px;
        }
        // 跑过的进度
        .rc-slider-track {
          position: absolute;
          background-color: #737596;
          height: 4px;
          left: 0%;
          width: 69.1515%;
          border-radius: 2px;
        }
        // 圆点
        .rc-slider-handle {
          position: absolute;
          margin-left: -8px;
          margin-top: -6px;
          left: 69.1515%;
          width: 16px;
          height: 16px;
          background-color: #737596;
          border: 0;
          cursor: -webkit-grab;
          cursor: grab;
          border-radius: 50%;
          -ms-touch-action: pan-x;
          touch-action: pan-x;
        }
      }
      .all-pages,
      .current-page {
        display: flex;
        justify-content: space-between;
        align-items: center;
        i.music-icon,
        i.mic-icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-left: 23px;
          margin-right: 21px;
          margin-top: 12px;
        }
        .music-icon {
          background: url('../../../static/svg/volume-music.svg') no-repeat
            center;
        }
        .mic-icon {
          background: url('../../../static/svg/volume-record.svg') no-repeat
            center;
        }
        .page {
          .range {
            width: 94px;
            color: #a5a7c6;
          }
        }
        .bgm-detail,
        .record-detail {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .duration {
            color: #a5a7c6;
          }
        }
        .control-btns {
          position: relative;
          width: 120px;
          input[type='checkbox'] {
            // appearance: none;
            -webkit-appearance: none;
            outline: none;
            display: none;
          }
          input[type='checkbox'] + label span {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 14px;
            height: 14px;
            margin-right: 9px;
            background: url('../../../static/svg/unchecked.svg') no-repeat
              center;
          }
          label {
            display: inline-flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            color: #474361;
          }
          input[type='checkbox']:checked + label span {
            background: url('../../../static/svg/checked.svg') no-repeat center;
          }
          .play,
          .stop,
          .del-icon {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            cursor: pointer;
          }
          .play {
            background: url('../../../static/svg/play.svg') no-repeat center;
            &:hover {
              background: url('../../../static/svg/play-active.svg') no-repeat
                center;
            }
          }
          .stop {
            background: url('../../../static/svg/vol-stop.svg') no-repeat center;
            &:hover {
              background: url('../../../static/svg/vol-stop-active.svg')
                no-repeat center;
            }
          }
          .del-icon {
            background: url('../../../static/svg/vol-del.svg') no-repeat center;
            &:hover {
              background: url('../../../static/svg/vol-del-active.svg')
                no-repeat center;
            }
          }
          .cropSound {
            width: 30px;
            height: 30px;
            background: #ddd;
            background: url('../../../static/svg/cropSound0.svg') no-repeat
              center;
            cursor: pointer;
            &:hover {
              background: url('../../../static/svg/cropSound1.svg') no-repeat
                center;
            }
          }
        }
        .sound-title {
          position: relative;
          text-align: left;
          .name {
            display: inline-block;
            width: 161px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .volume-bar {
            display: flex;
            align-items: center;
            justify-content: center;
            i.volume-icon {
              display: inline-block;
              width: 18px;
              height: 14px;
              margin-right: 15px;
              background: url('../../../static/svg/volume.svg') no-repeat center;
            }
            .volume-tip {
              padding-left: 1.5em;
              width: 50px;
            }
          }
        }
        .no-bgm,
        .no-record {
          width: 300px;
          cursor: pointer;

          & > i,
          & > span {
            display: block;
            margin: auto;
          }
          & > span {
            margin-top: 18px;
          }
          &:hover {
          }
        }
      }
      .all-pages {
        height: 106px;
        border-bottom: 1px solid #d9ddea;
      }
      .current-page {
        height: 105px;
      }
      .hide-slider {
        opacity: 0;
        z-index: -1;
      }
    }
    .audition {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 70px;
      color: #474261;
      background-color: #f8f8fe;
      .play,
      .stop {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        margin-left: 21px;
        margin-right: 13px;
        border-radius: 50%;
        cursor: pointer;
      }
      .play {
        background: url('../../../static/svg/play.svg') no-repeat center;
        &:hover {
          background: url('../../../static/svg/play-active.svg') no-repeat
            center;
        }
      }
      .stop {
        background: url('../../../static/svg/stop.svg') no-repeat center;
        &:hover {
          background: url('../../../static/svg/stop-active.svg') no-repeat
            center;
        }
      }
    }

    .cropSoundBox {
      position: absolute;
      top: 0;
      left: 0;
      padding-top: 70px;
      background: #fff;
      width: 100%;
      height: 280px;
      z-index: 10;

      .arrowBtn {
        position: absolute;
        top: 16px;
        left: 30px;
        width: 100px;
        height: 36px;
        background-color: #f0f0f8;
        border-radius: 4px;
        color: #474261;
        cursor: pointer;
        line-height: 36px;

        .icon {
          vertical-align: baseline;
          margin-right: 3px;
          margin-bottom: -2px;
        }
      }
      .cropTool {
        position: relative;
        padding-left: 40px;

        .scaleBar {
          position: relative;
          width: 380px;
          height: 40px;
          background: url(/static/img/timeBar.png) no-repeat center;
          background-size: contain;
          background-color: #f0f0f8;

          .scaleBarBg {
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 40px;
            background: url(/static/img/timeBarActive.png) no-repeat center;
            background-color: #d4d4f2;
            background-size: 365px auto;
          }

          .scaleBarBtn {
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 40px;
            border: solid 1px #5778fb;

            .scaleBarBtnLeft,
            .scaleBarBtnRight {
              position: absolute;
              top: -1px;
              width: 10px;
              height: 40px;
              background-color: #5778fb;
              border-radius: 4px 0 0 4px;
              cursor: pointer;
              color: #fff;
              line-height: 40px;
              text-indent: -2px;
            }
            .scaleBarBtnLeft {
              left: -10px;
            }

            .scaleBarBtnRight {
              right: -10px;
              border-radius: 0 4px 4px 0;
            }

            .timeIconRight,
            .timeIconLeft {
              position: absolute;
              top: -26px;
              width: 70px;
              height: 26px;
              color: #474261;

              span {
                position: absolute;
                top: 0;
                left: 0;
                width: 70px;
                height: 19px;
                border-radius: 9px;
              }
            }
            .timeIconLeft {
              text-align: left;
              left: -35px;
            }
            .timeIconRight {
              text-align: right;
              right: -35px;
            }
          }

          .timeBar {
            position: absolute;
            top: -3px;
            left: 0;
            width: 2px;
            height: 46px;
            background-color: #5778fb;

            span {
              position: absolute;
              top: -25px;
              left: -32px;
              width: 70px;
              height: 19px;
              border-radius: 9px;
            }
          }
        }
        .soundDuration {
          position: absolute;
          top: 0;
          left: 435px;
          height: 40px;
          line-height: 40px;
          color: #474261;
        }
      }
      .cropBtnBox {
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        margin: auto;
        width: 100%;
        height: 69px;
        background-color: #f8f8fe;

        .cropBtn {
          position: absolute;
          bottom: 0px;
          left: 0px;
          right: 0px;
          top: 0px;
          margin: auto;
          width: 31px;
          height: 30px;
          background-color: #474261;
          border-radius: 100%;
          color: #fff;
          font-size: 17px;
          line-height: 30px;
          cursor: pointer;
        }
        .cropBtnRectangle:before {
          content: '';
          width: 10px;
          height: 10px;
          background: #fff;
          position: absolute;
          bottom: 0px;
          left: 0px;
          right: 0px;
          top: 0px;
          margin: auto;
        }
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/volume.vue